export enum ActionApprovalStatus {
  NOT_SET = 'not-set',
  WAITING_FOR_APPROVAL = 'waiting-for-approval',
  APPROVED = 'approved',
  DENIED = 'denied',
}
